import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBoxes,
  faTag,
  faShoppingCart,
  faUsers,
  faChartBar,
  faCreditCard,
  faDoorOpen,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useNavbarStore } from "../../zustand/navbarStore";
import { useAuthStore } from "../../zustand/loginStore";
import CustomNavbar from "./CustomNavbar";
import Users from "./Users";
import InventoriesMenu from "../inventories/InventoriesMenu";
import Promotions from "components/promotions/Promotions";
import { Orders } from "components/orders";
import { Payments } from "components/payments/Payments";
import Reports from "components/reports/Reports";

const Dashboard: React.FC = () => {
  const { selectedNav, setSelectedNav } = useNavbarStore();
  const { setToken } = useAuthStore();
  const navigate = useNavigate();

  const menuItems = [
    {
      id: "tablero",
      title: "Tablero Principal",
      description: "Resumen general y estadísticas principales",
      icon: faHome,
      color: "#997404",
    },
    {
      id: "inventarios",
      title: "Inventarios",
      description: "Gestión de productos, stock y categorías",
      icon: faBoxes,
      color: "#997404",
    },
    {
      id: "promociones",
      title: "Promociones",
      description: "Crear y gestionar ofertas especiales",
      icon: faTag,
      color: "#FBE584",
    },
    {
      id: "pedidos",
      title: "Pedidos",
      description: "Gestión completa de órdenes de compra",
      icon: faShoppingCart,
      color: "#997404",
    },
    {
      id: "usuarios",
      title: "Usuarios",
      description: "Administrar cuentas y perfiles de usuario",
      icon: faUsers,
      color: "#C1C1C1",
    },
    {
      id: "reportes",
      title: "Reportes",
      description: "Análisis detallado y estadísticas de ventas",
      icon: faChartBar,
      color: "#FBE584",
    },
    {
      id: "pagos",
      title: "Pagos",
      description: "Gestión de transacciones y métodos de pago",
      icon: faCreditCard,
      color: "#997404",
    },
  ];

  const handleMenuClick = (itemId: string) => {
    setSelectedNav(itemId);
    navigate(`/dashboard#${itemId}`);
  };

  const handleBackToHome = () => {
    setSelectedNav("tablero");
  };

  const handleLogout = () => {
    navigate("/adminLogin");
    setToken(null);
  };

  const renderDashboardHome = () => (
    <div
      className="dashboard-home"
      style={{
        backgroundColor: "#f8f9fa",
        minHeight: "calc(100vh - 80px)",
        padding: "30px 0",
      }}
    >
      <Container fluid className="mb-5">
        <Row className="justify-content-center">
          <Col lg={8} md={10} sm={12}>
            <Card
              className="text-center shadow-lg mb-5"
              style={{
                border: "none",
                borderRadius: "20px",
                background: "linear-gradient(135deg, #997404 0%, #FBE584 100%)",
                boxShadow: "0 10px 30px rgba(153, 116, 4, 0.3)",
              }}
            >
              <Card.Body className="py-5">
                <h1
                  className="dashboard-title mb-3"
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "2.5rem",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                  }}
                >
                  Panel de Administración
                </h1>
                <p
                  className="dashboard-subtitle mb-0"
                  style={{
                    color: "white",
                    fontSize: "1.2rem",
                    fontWeight: "500",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
                  }}
                >
                  Gestiona tu boutique desde un solo lugar
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Container fluid>
        <Row className="menu-grid justify-content-center">
          {menuItems
            .filter((item) => item.id !== "tablero")
            .map((item) => (
              <Col lg={4} md={6} sm={12} key={item.id} className="mb-4">
                <Card
                  className="menu-card h-100"
                  onClick={() => handleMenuClick(item.id)}
                  style={{
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    border: "none",
                    borderRadius: "20px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    background: "white",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.boxShadow =
                      "0 15px 40px rgba(153, 116, 4, 0.2)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0px)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 25px rgba(0,0,0,0.1)";
                  }}
                >
                  <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                    <div
                      className="menu-icon-container mb-3"
                      style={{
                        width: "90px",
                        height: "90px",
                        borderRadius: "50%",
                        backgroundColor: "#997404",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 6px 20px rgba(153, 116, 4, 0.3)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={item.icon}
                        className="menu-icon"
                        style={{
                          fontSize: "2.2rem",
                          color: "white",
                        }}
                      />
                    </div>
                    <Card.Title
                      className="menu-title mb-2"
                      style={{
                        color: "#614900",
                        fontWeight: "bold",
                        fontSize: "1.4rem",
                      }}
                    >
                      {item.title}
                    </Card.Title>
                    <Card.Text
                      className="menu-description mb-3"
                      style={{
                        color: "#666",
                        fontSize: "1rem",
                        lineHeight: "1.5",
                      }}
                    >
                      {item.description}
                    </Card.Text>
                    <Button
                      className="mt-auto"
                      style={{
                        backgroundColor: "#997404",
                        border: "none",
                        borderRadius: "30px",
                        padding: "12px 30px",
                        fontWeight: "bold",
                        color: "white",
                        boxShadow: "0 4px 15px rgba(153, 116, 4, 0.3)",
                        transition: "all 0.3s ease",
                        fontSize: "1rem",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#fbe584";
                        e.currentTarget.style.color = "black";
                        e.currentTarget.style.transform = "scale(1.08)";
                        e.currentTarget.style.boxShadow =
                          "0 6px 20px rgba(251, 229, 132, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#997404";
                        e.currentTarget.style.color = "white";
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow =
                          "0 4px 15px rgba(153, 116, 4, 0.3)";
                      }}
                    >
                      Acceder
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </Container>
    </div>
  );

  const renderSelectedContent = () => {
    if (selectedNav === "tablero" || !selectedNav) {
      return renderDashboardHome();
    }

    return (
      <div className="dashboard-content">
        <div className="content-body">
          {selectedNav === "usuarios" && <Users />}
          {selectedNav === "inventarios" && <InventoriesMenu />}
          {selectedNav === "promociones" && <Promotions />}
          {selectedNav === "pedidos" && <Orders />}
          {selectedNav === "reportes" && <Reports />}
          {selectedNav === "pagos" && <Payments />}
        </div>
      </div>
    );
  };

  return (
    <div className="dashboard-container">
      <CustomNavbar />
      <div style={{ paddingTop: "20px" }}>{renderSelectedContent()}</div>
    </div>
  );
};

export default Dashboard;
